import React, { forwardRef, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { PillValue } from '../Pill/PillValue.js';
export const FilterValueButton = forwardRef((props, ref) => {
    const intl = useIntl();
    const { isOpen, items, label, disabled, selectedItemLabels, enableSelectAll, addClassName, ...rest } = props;
    const selectableItemsCount = useMemo(() => {
        if (enableSelectAll) {
            return items.length;
        }
        return null;
    }, [enableSelectAll, items]);
    const displayValue = selectedItemLabels.length === selectableItemsCount
        ? intl.formatMessage({
            defaultMessage: 'All',
            id: '0jcnlJ',
            description: 'Label on select showing all items have been selected'
        })
        : selectedItemLabels.map(String).join(', ');
    return (React.createElement(PillValue, { isFullWidth: rest.isFullWidth, labelKey: label, labelValue: displayValue, disabled: disabled, isOpen: isOpen, addClassName: addClassName, required: rest.required, ref: ref, ...rest }));
});
FilterValueButton.displayName = 'FilterValueButton';
//# sourceMappingURL=FilterValueButton.js.map